import {fullReports, shortReports} from "@/mixins/dictionaries/reports";

export default function getReportName(type, short = false) {
    let translateObject = short ? shortReports : fullReports;
    return Object.keys(translateObject).find(k => translateObject[k] === type) ?? 'Тестирование';
}